import englishMessages from "ra-language-english";

const customEnglishMessages = {
  ...englishMessages,
};
export default customEnglishMessages;
